import OrganizationUsersPage from "./organizationUsers";

export default OrganizationUsersPage;